export default __webpack_public_path__ + "static/media/Metlife.0a27ec46.svg";